// User type identifiers
export const defaultMessagesFilter = 'all';

export const userType = {
  ADMIN: "admin",
  CUSTOMER: "user",
  DRIVER: "mav",
};

// Timing and refresh intervals (ms / s)
export const messageRefreshInterval = 5000;
export const findJobLocationRefreshLimit = 3600;
export const serverTimeout = 20000;
export const longPressTime = 1000;
export const scrollAnimTime = 500;
export const bookButProgressDelay = 50;

// Job / quote business rules
export const jobMustHavePic = false;
export const defaultCommission = 0.15;
export const defaultMaxJobValue = 2501;
export const jobBookMaxFutureDays = -60;
export const jobBookTimeMinuteInc = 15;
export const listThresholdForSearch = 5;

// Date / geo defaults
export const bookTodayTimeCuotoff = 20;
export const cancellationRefundLimitHours = -24;
export const defaultLatitude = 51.508457;
export const defaultLongitude = -0.087646;
export const defaultRadius = 500;

// Message moderation rules
export const messageRulesFlags = {
  money: {
    messageTypes: ["quote"],
    test: ["containsMoneyRegExp", "containsMoneyRegExp2"],
    string: "It looks like it contains reference to money.",
  },
  contact: {
    messageTypes: ["quote"],
    test: ["containsContactRegExp"],
    string: "It looks like it contains contact information.",
  },
};

export const messageRulesBlocks = {
  email: {
    messageTypes: ["quote", "book"],
    test: ["containsEmailRegExp"],
    string: "It looks like it contains an email address.",
  },
  link: {
    messageTypes: ["quote", "book"],
    test: ["containsUrlRegExp", "containsUrlRegExp2"],
    string: "It looks like it contains a link.",
  },
  phone: {
    messageTypes: ["quote", "book"],
    test: ["containsTelephoneRegExp", "containsTelephoneRegExp2"],
    string: "It looks like it contains a phone number.",
  },
  profanity: {
    messageTypes: ["quote", "book", "conversation"],
    test: ["containsProfanityRegExp"],
    string: "It looks like it contains foul language.",
  },
  reviewemail: {
    messageTypes: ["review"],
    test: ["containsEmailRegExp"],
    string: "It looks like this review contains an email address.",
  },
  reviewlink: {
    messageTypes: ["review"],
    test: ["containsUrlRegExp", "containsUrlRegExp2"],
    string: "It looks like this review contains a link.",
  },
  reviewphone: {
    messageTypes: ["review"],
    test: ["containsTelephoneRegExp", "containsTelephoneRegExp2"],
    string: "It looks like this review contains a phone number.",
  },
  reviewprofanity: {
    messageTypes: ["review"],
    test: ["containsProfanityRegExp"],
    string: "It looks like this review contains foul language.",
  },
  feedbackprofanity: {
    messageTypes: ["feedback"],
    test: ["containsProfanityRegExp"],
    string: "It looks like this review contains foul language.",
  },
};

export const quoteDeclineFeedback = {
  1: "Too Expensive",
  2: "Not enough helpers",
  3: "Driver not licensed for this type of waste",
  4: "I No longer require a Man + Van",
  5: "I was just looking for an idea of prices",
  6: "Something else",
};

// Dev/test fixtures
export const testValidation1 = {
  "job.jobSpec.serviceDescription": true,
  "job.destinationAddress.formattedAddress": true,
  "job.originAddress.formattedAddress": true,
  "job.jobSpec.expectedPrice": true,
};

export const testJob1 = {
  originAddress: {
    googleValidated: "passed",
    placeId: "ChIJkznAeYs3eUgRMdNyPECsO5E",
    streetNumber: "",
    streetName: "",
    postCode: "LS24",
    townCityName: "Tadcaster",
    regionName: "",
    countryName: "United Kingdom",
    formattedAddress: "Tadcaster LS24, UK",
    addressGeometry: {
      coordinates: [-1.2675371, 53.8822437],
      type: "Point",
    },
  },
  destinationAddress: {
    googleValidated: "passed",
    placeId: "ChIJFb7o-qkKeUgReLAGr_UnKD4",
    streetNumber: "",
    streetName: "",
    postCode: "",
    townCityName: "Sheffield",
    regionName: "South Yorkshire",
    countryName: "United Kingdom",
    formattedAddress: "Sheffield, UK",
    addressGeometry: {
      coordinates: [-1.470085, 53.38112899999999],
      type: "Point",
    },
  },
  originDestinationDistance: {
    theDistance: "53.6 mi",
    theDuration: "1 hour 4 mins",
  },
  jobSpec: {
    specVersion: 2,
    serviceType: "dispose",
    serviceSubType: "houseclearance",
    serviceDescription:
      "Item details lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    dateAndTime: {
      type: "thisweek",
      days: {
        Monday: false,
        Tuesday: true,
        Wednesday: true,
        Thursday: true,
        Friday: false,
        Saturday: false,
        Sunday: false,
      },
      timeRange: { min: 10, max: 21 },
      standardDate: new Date("Mon Mar 16 2020 12:00:00 GMT+0700"),
    },
    serviceChecklist: {
      requirestwo: false,
      involvesstairs: true,
      nonepresentfrom: false,
    },
    numberOfItems: 1,
    priceType: "fixed",
    expectedPrice: 100,
    jobImages: [],
  },
  userId: "test-user-id",
  status: "open",
};

export const JOB_TYPES = [
  { id: "sendItems", label: "Send items" },
  { id: "houseMove", label: "House Move" },
  { id: "disposalOfItems", label: "Dispose of items" },
  { id: "wasteRemoval", label: "Waste removal" },
  { id: "houseClearance", label: "House clearance" },
];

export const DISCOUNT_AMOUNTS = ["5%", "10%", "15%", "20%"];

export const DISCOUNT_FILTERS = {
  type: [
    { value: "all", label: "All discount types" },
    { value: "client-specific", label: "Client-specific" },
    { value: "general", label: "General" },
  ],
  status: [
    { value: "all", label: "All" },
    { value: "active", label: "Active" },
    { value: "scheduled", label: "Scheduled" },
    { value: "expired", label: "Expired" },
    { value: "used", label: "Used" },
  ],
  campaign: [
    { value: "any", label: "Any campaign" },
    { value: "spring", label: "Spring promotion" },
    { value: "new-clients", label: "New clients" },
    { value: "house-move", label: "House move campaign" },
    { value: "none", label: "None" },
  ],
};

export const STATUS_BADGE_MAP = {
  active: "badge-success",
  scheduled: "badge-warning",
  expired: "badge-danger",
  used: "badge-info",
};

export const DISCOUNT_TYPE_BADGE_MAP = {
  "auto-applied": "badge-light-warning",
  default: "badge-light",
};

export const STATIC_CLIENTS = [
  { _id: "1", name: "David Brown", id: "C2226", status: "active" },
  { _id: "2", name: "John Smith", id: "C2222", status: "active" },
  { _id: "3", name: "Sarah Johnson", id: "C2223", status: "active" },
  { _id: "4", name: "Mike Wilson", id: "C2224", status: "active" },
  { _id: "5", name: "Emma Davis", id: "C2225", status: "active" },
];

export const STATIC_CAMPAIGNS_LIST = [
  {
    _id: "1",
    name: "Spring promotion",
    description: "Clients booking during the spring promotion period",
  },
  {
    _id: "2",
    name: "New clients",
    description: "Clients placing their first Man & Van booking",
  },
  {
    _id: "3",
    name: "House move campaign",
    description: "Clients booking house moves and larger jobs",
  },
];

export const INITIAL_SPECIFIC_JOBS = {
  sendItems: false,
  houseMove: false,
  disposalOfItems: false,
  wasteRemoval: false,
  houseClearance: false,
};

export const DISCOUNT_COLUMNS = [
  { key: "select", label: "", sortable: false },
  { key: "code", label: "Discount codes", sortable: true, sortKey: "code" },
  { key: "discountType", label: "Discount type", sortable: true, sortKey: "discountType" },
  { key: "status", label: "Status", sortable: true, sortKey: "status" },
  { key: "uses", label: "Uses", sortable: true, sortKey: "uses" },
  { key: "startDate", label: "Start Date", sortable: true, sortKey: "startDate" },
  { key: "endDate", label: "End Date", sortable: true, sortKey: "endDate" },
  { key: "actions", label: "", sortable: false },
];

export const CAMPAIGN_COLUMNS = [
  { key: "name", label: "Campaign", sortable: true, sortKey: "name" },
  { key: "audience", label: "Audience", sortable: false },
  { key: "discountCodes", label: "Discount codes", sortable: true, sortKey: "discountCodes" },
  { key: "activeCodes", label: "Active codes", sortable: true, sortKey: "activeCodes" },
  { key: "totalUses", label: "Total uses", sortable: true, sortKey: "totalUses" },
  { key: "created", label: "Created", sortable: true, sortKey: "created" },
  { key: "actions", label: "", sortable: false },
];

export const SORT_FIELDS_DISCOUNTS = {
  code: { asc: "code=1", desc: "code=-1" },
  discountType: { asc: "discountType=1", desc: "discountType=-1" },
  status: { asc: "status=1", desc: "status=-1" },
  uses: { asc: "uses=1", desc: "uses=-1" },
  startDate: { asc: "startDate=1", desc: "startDate=-1" },
  endDate: { asc: "endDate=1", desc: "endDate=-1" },
};

export const SORT_FIELDS_CAMPAIGNS = {
  name: { asc: "name=1", desc: "name=-1" },
  discountCodes: { asc: "discountCodes=1", desc: "discountCodes=-1" },
  activeCodes: { asc: "activeCodes=1", desc: "activeCodes=-1" },
  totalUses: { asc: "totalUses=1", desc: "totalUses=-1" },
  created: { asc: "created=1", desc: "created=-1" },
};

export const BUTTON_STYLES = {
  primary: {
    backgroundColor: "#229954",
    "&:hover": {
      backgroundColor: "#1e8449",
    },
  },
  danger: {
    backgroundColor: "#dc3545",
    "&:hover": {
      backgroundColor: "#c82333",
    },
  },
  edit: {
    backgroundColor: "#6c757d",
    "&:hover": { backgroundColor: "#5a6268" },
  },
  link: {
    backgroundColor: "#17a2b8",
    "&:hover": { backgroundColor: "#138496" },
  },
  dark: {
    backgroundColor: "#000",
    "&:hover": { backgroundColor: "#1a1a1a" },
  },
};

export const MOCK_FLAGGED_IMAGES = [
  {
    _id: "1",
    user: {
      firstname: "Mike Johnson",
      shortId: "D2222",
      avatar: "avatar1.jpg",
    },
    imageType: "avatar",
    image:
      "https://static.vecteezy.com/system/resources/thumbnails/052/248/811/small/autumn-leaf-wallpaper-hd-wallpaper-free-photo.jpeg",
    reason: "Explicit image content",
    flaggedAt: new Date(2025, 3, 10),
  },
  {
    _id: "2",
    user: {
      firstname: "Emma Wilson",
      shortId: "C2221",
      avatar: "avatar2.jpg",
    },
    imageType: "jobPhoto",
    image: "https://picsum.photos/seed/driver-avatar-explicit/300/300",
    reason: "Explicit image content",
    flaggedAt: new Date(2025, 3, 10),
  },
  {
    _id: "3",
    user: {
      firstname: "Emily Davis",
      shortId: "C2229",
      avatar: "avatar3.jpg",
    },
    imageType: "jobPhoto",
    image: "https://picsum.photos/seed/client-avatar-explicit/300/300",
    reason: "Sharing contact info via image",
    flaggedAt: new Date(2025, 3, 9),
  },
  {
    _id: "4",
    user: {
      firstname: "Daniel Carrier",
      shortId: "D2226",
      avatar: "avatar4.jpg",
    },
    imageType: "avatar",
    image:
      "https://static.vecteezy.com/system/resources/thumbnails/052/248/811/small/autumn-leaf-wallpaper-hd-wallpaper-free-photo.jpeg",
    reason: "Sharing contact info via image",
    flaggedAt: new Date(2025, 3, 9),
  },
];

export const MOCK_DISCOUNTS = [
  {
    _id: "1",
    code: "DAVID358H6M",
    description: "15% discount · Min. £250 · Waste removal",
    assignedTo: "Assigned to David Brown (C2226)",
    discountType: "Client-specific - auto-applied",
    status: "Scheduled",
    uses: "0/1",
    startDate: "10 Sep 26",
    startTime: "18:01",
    endDate: "—",
    endTime: "",
    campaign: "—",
  },
  {
    _id: "2",
    code: "JOHNUR7K9P",
    description: "10% discount",
    assignedTo: "Assigned to John Smith (C2222)",
    discountType: "Client-specific - auto-applied",
    status: "Used",
    uses: "1/1",
    startDate: "20 Jan 26",
    startTime: "05:30",
    endDate: "31 Mar 26",
    endTime: "05:30",
    campaign: "—",
  },
  {
    _id: "3",
    code: "SEND15",
    description: "15% discount · Min. £1000 · Send items",
    assignedTo: "",
    discountType: "General - manual code",
    status: "Scheduled",
    uses: "12/50",
    startDate: "18 Sep 26",
    startTime: "18:01",
    endDate: "—",
    endTime: "",
    campaign: "House move campaign",
  },
  {
    _id: "4",
    code: "MOVE20",
    description: "20% discount · Min. £500 · House move",
    assignedTo: "",
    discountType: "General - manual code",
    status: "Active",
    uses: "32/100",
    startDate: "1 May 23",
    startTime: "05:30",
    endDate: "31 Dec 26",
    endTime: "05:30",
    campaign: "House move campaign",
  },
  {
    _id: "5",
    code: "SPRING2023",
    description: "10% discount · Once per customer",
    assignedTo: "",
    discountType: "General - manual code",
    status: "Expired",
    uses: "45",
    startDate: "1 Mar 23",
    startTime: "05:30",
    endDate: "1 Jun 23",
    endTime: "05:30",
    campaign: "Spring promotion",
  },
  {
    _id: "6",
    code: "WELCOME10",
    description: "10% discount · Once per customer",
    assignedTo: "",
    discountType: "General - manual code",
    status: "Active",
    uses: "215",
    startDate: "1 Jan 23",
    startTime: "—",
    endDate: "—",
    endTime: "",
    campaign: "—",
  },
];

export const MOCK_CAMPAIGNS = [
  {
    _id: "1",
    name: "Spring promotion",
    audience: "Clients booking during the spring promotion period",
    discountCodes: 1,
    activeCodes: 0,
    totalUses: 45,
    created: "10 Feb 23",
  },
  {
    _id: "2",
    name: "New clients",
    audience: "Clients placing their first Man & Van booking",
    discountCodes: 1,
    activeCodes: 1,
    totalUses: 215,
    created: "15 Dec 22",
  },
  {
    _id: "3",
    name: "House move campaign",
    audience: "Clients booking house moves and larger jobs",
    discountCodes: 2,
    activeCodes: 1,
    totalUses: 44,
    created: "20 Apr 23",
  },
];

// ─── Transfers ──────────────────────────────────────────────────────────────

export const TRANSFER_COLUMNS = [
  { key: "driver",      label: "Driver",       sortable: true, sortKey: "firstname"         },
  { key: "transfer",    label: "Transfer",     sortable: true, sortKey: "statusSorter"      },
  { key: "driverPay",   label: "Driver Pay",   sortable: true, sortKey: "amountSorter"      },
  { key: "jobType",     label: "Job Type",     sortable: true, sortKey: "jobType"           },
  { key: "jobLocation", label: "Job Location", sortable: true, sortKey: "location"          },
  { key: "completedOn", label: "Completed on", sortable: true, sortKey: "completedOnSorter" },
  { key: "actions",     label: "" },
];

export const TRANSFER_SORT_FIELDS = {
  firstname:         { asc: "firstname=1",         desc: "firstname=-1"         },
  amountSorter:      { asc: "amountSorter=1",      desc: "amountSorter=-1"      },
  statusSorter:      { asc: "statusSorter=1",      desc: "statusSorter=-1"      },
  completedOnSorter: { asc: "completedOnSorter=1", desc: "completedOnSorter=-1" },
  location:          { asc: "location=1",          desc: "location=-1"          },
  jobType:           { asc: "jobType=1",           desc: "jobType=-1"           },
};

export const TRANSFER_TYPE_OPTIONS = [
  { value: "all",      label: "All"       },
  { value: "pending",  label: "Pending"   },
  { value: "approved", label: "Completed" },
  { value: "rejected", label: "Rejected"  },
];

export const TRANSFER_PAYMENT_STATUS = {
  pending:  { badgeClass: "badge-warning",   label: "Pending"   },
  complete: { badgeClass: "badge-success",   label: "Completed" },
  rejected: { badgeClass: "badge-danger",    label: "Rejected"  },
};

// ─── Support ────────────────────────────────────────────────────────────────

export const SUPPORT_COLUMNS = [
  { key: "user",        label: "Conversation with", sortable: true, sortKey: "user"        },
  { key: "unreadCount", label: "Unread",             sortable: true, sortKey: "unreadCount" },
  { key: "message",     label: "Last message",       sortable: true, sortKey: "message"     },
  { key: "sentAt",      label: "Sent at",            sortable: true, sortKey: "sentAt"      },
  { key: "actions",     label: "" },
];

export const SUPPORT_SORT_FIELDS = {
  user:        { asc: "user=1",        desc: "user=-1"        },
  unreadCount: { asc: "unreadCount=1", desc: "unreadCount=-1" },
  message:     { asc: "message=1",     desc: "message=-1"     },
  sentAt:      { asc: "sentAt=1",      desc: "sentAt=-1"      },
};

export const SUPPORT_USER_TYPE_OPTIONS = [
  { value: "any",    label: "Any"    },
  { value: "client", label: "Client" },
  { value: "driver", label: "Driver" },
];

export const SUPPORT_STATUS_OPTIONS = [
  { value: "any",    label: "Any"    },
  { value: "read",   label: "Read"   },
  { value: "unread", label: "Unread" },
];

export const STATIC_SUPPORT_CONVERSATIONS = [
  {
    id: 1,
    supportChatUser: { name: "Walter",         shortId: "FKCJNPJH6", avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face", type: "client" },
    disputeUser:     { name: "Shakir Smith",   shortId: "C6364S8",   avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face", type: "admin"  },
    supportChatMessage:  "It has been 20 minutes past the scheduled time",
    disputeMessage:      "I've completed all the required documentation. Please let me know if anything else is needed.",
    supportChatUnreadCount: 3, disputeUnreadCount: 0,
    supportChatSentAt: { date: "9 Apr 25",  time: "10:25" },
    disputeSentAt:     { date: "9 Apr 25",  time: "10:25" },
  },
  {
    id: 2,
    supportChatUser: { name: "Emily Johnson", shortId: "C785432",   avatar: "https://randomuser.me/api/portraits/women/44.jpg", type: "admin"  },
    disputeUser:     { name: "Michael Lee",   shortId: "D238473",   avatar: "https://randomuser.me/api/portraits/men/33.jpg",   type: "driver" },
    supportChatMessage:  "The driver didn't arrive at the pickup location.",
    disputeMessage:      "I was at the location on time, but no one showed up.",
    supportChatUnreadCount: 0, disputeUnreadCount: 1,
    supportChatSentAt: { date: "10 Apr 25", time: "14:40" },
    disputeSentAt:     { date: "10 Apr 25", time: "14:35" },
  },
  {
    id: 3,
    supportChatUser: { name: "David Wilson",  shortId: "C002134",   avatar: "https://randomuser.me/api/portraits/men/12.jpg",   type: "driver" },
    disputeUser:     { name: "Anna Kim",      shortId: "D556789",   avatar: "https://randomuser.me/api/portraits/women/68.jpg", type: "client" },
    supportChatMessage:  "I was charged twice for the same ride.",
    disputeMessage:      "There must be a technical error in the billing system.",
    supportChatUnreadCount: 2, disputeUnreadCount: 2,
    supportChatSentAt: { date: "11 Apr 25", time: "09:10" },
    disputeSentAt:     { date: "11 Apr 25", time: "09:12" },
  },
  {
    id: 4,
    supportChatUser: { name: "Sophia Brown",  shortId: "C998877",   avatar: "https://randomuser.me/api/portraits/women/12.jpg", type: "driver" },
    disputeUser:     { name: "James Taylor",  shortId: "D334455",   avatar: "https://randomuser.me/api/portraits/men/54.jpg",   type: "driver" },
    supportChatMessage:  "The vehicle was not clean and had a strong odor.",
    disputeMessage:      "I cleaned the car before the trip. The complaint might be exaggerated.",
    supportChatUnreadCount: 1, disputeUnreadCount: 0,
    supportChatSentAt: { date: "12 Apr 25", time: "11:45" },
    disputeSentAt:     { date: "12 Apr 25", time: "11:47" },
  },
  {
    id: 5,
    supportChatUser: { name: "Olivia Davis",  shortId: "C765432",   avatar: "https://randomuser.me/api/portraits/women/90.jpg", type: "client" },
    disputeUser:     { name: "Chris Martin",  shortId: "D112233",   avatar: "https://randomuser.me/api/portraits/men/23.jpg",   type: "admin"  },
    supportChatMessage:  "The driver was very rude during the trip.",
    disputeMessage:      "I remained professional throughout. The passenger was upset about traffic delays.",
    supportChatUnreadCount: 0, disputeUnreadCount: 4,
    supportChatSentAt: { date: "13 Apr 25", time: "08:30" },
    disputeSentAt:     { date: "13 Apr 25", time: "08:35" },
  },
];

// ─── Conversations ───────────────────────────────────────────────────────────

export const CONVERSATION_SENDER_OPTIONS = [
  { value: "any",    label: "Any"    },
  { value: "client", label: "Client" },
  { value: "driver", label: "Driver" },
];

export const CONVERSATIONS_COLUMNS = [
  { key: "client",  label: "Client"  },
  { key: "message", label: "Message" },
  { key: "driver",  label: "Driver"  },
  { key: "sentAt",  label: "Sent at" },
  { key: "actions", label: ""        },
];

export const STATIC_CONVERSATIONS = [
  {
    id: 1,
    client: { name: "Walter",     shortId: "FKCJNPJH6", avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b5e4?w=150&h=150&fit=crop&crop=face", type: "client" },
    userType: "driver",
    message: "Thank you so much for your help today! You made this move so much easier.",
    driver: { name: "Nick",         shortId: "P3NEF44T9", avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face", hasNotification: true, type: "driver" },
    sentAt: { date: "9 Apr 25", time: "16:30" },
  },
  {
    id: 2,
    client: { name: "John Doe",   shortId: "C567890",   avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b5e4?w=150&h=150&fit=crop&crop=face", type: "client" },
    userType: "client",
    message: "All done! Everything has been unloaded and placed according to your instructions.",
    driver: { name: "Jane Smith",  shortId: "D234567",   avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face", hasNotification: true, type: "driver" },
    sentAt: { date: "9 Apr 25", time: "16:15" },
  },
  {
    id: 3,
    client: { name: "Jane Smith", shortId: "C567890",   avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b5e4?w=150&h=150&fit=crop&crop=face", type: "client" },
    userType: "driver",
    message: "Great! I will meet you there in about 20 minutes.",
    driver: { name: "John Doe",    shortId: "D234567",   avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face", hasNotification: true, type: "driver" },
    sentAt: { date: "9 Apr 25", time: "12:35" },
  },
  {
    id: 4,
    client: { name: "Smith",      shortId: "C567890",   avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b5e4?w=150&h=150&fit=crop&crop=face", type: "client" },
    userType: "client",
    message: "We have finished loading everything. Heading to the new place now.",
    driver: { name: "John Doe",    shortId: "D234567",   avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face", hasNotification: true, type: "driver" },
    sentAt: { date: "9 Apr 25", time: "12:30" },
  },
  {
    id: 5,
    client: { name: "bro",        shortId: "C567890",   avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b5e4?w=150&h=150&fit=crop&crop=face", type: "client" },
    userType: "client",
    message: "Coming down now!",
    driver: { name: "Thomas Moore", shortId: "D234567",  avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face", hasNotification: true, type: "driver" },
    sentAt: { date: "9 Apr 25", time: "10:16" },
  },
  {
    id: 6,
    client: { name: "Johnny",     shortId: "C567890",   avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b5e4?w=150&h=150&fit=crop&crop=face", type: "client" },
    userType: "driver",
    message: "I have arrived and am parked outside",
    driver: { name: "Thomas Moore", shortId: "D234567",  avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face", hasNotification: true, type: "driver" },
    sentAt: { date: "9 Apr 25", time: "10:15" },
  },
];

export const periodButtons = [
  { id: "custom", label: "Custom range" },
  { id: "7D", label: "7D" },
  { id: "30D", label: "30D" },
  { id: "3M", label: "3M" },
  { id: "6M", label: "6M" },
  { id: "12M", label: "12M" },
];

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
